var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "accordion interment-item-wrapper" }, [
    _c("div", { staticClass: "card" }, [
      _c(
        "div",
        {
          staticClass: "card-header",
          attrs: { id: `heading-interment-${_vm.indexItem}` },
        },
        [
          _c(
            "button",
            {
              staticClass: "btn btn-link btn-block interment-header",
              attrs: {
                type: "button",
                "aria-expanded": "false",
                "data-toggle": "collapse",
                "data-target": `#collapse-interment-${_vm.indexItem}`,
                "aria-controls": `#collapse-interment-${_vm.indexItem}`,
              },
            },
            [
              _vm._m(0),
              _vm._v(" "),
              _c("div", { staticClass: "up-to-3-entities" }, [
                _c("div", {
                  staticClass: "divider",
                  staticStyle: { display: "none" },
                }),
                _vm._v(" "),
                _c("div", { staticClass: "entity-info" }, [
                  _c("div", { staticClass: "container-name-label" }, [
                    _c("h3", { staticClass: "entity-full-name" }, [
                      _c("span", [_vm._v(_vm._s(_vm.entityName))]),
                    ]),
                    _vm._v(" "),
                    _vm._m(1),
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "entity-dates-age" }, [
                    _vm._v(
                      "\n                            " +
                        _vm._s(_vm.entityDatesAge) +
                        "\n                        "
                    ),
                  ]),
                ]),
              ]),
            ]
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "collapse",
          attrs: {
            id: `collapse-interment-${_vm.indexItem}`,
            "aria-labelledby": `heading-interment-${_vm.indexItem}`,
          },
        },
        [
          _c("div", { staticClass: "card-body" }, [
            _c("div", { staticClass: "interment-item-content" }, [
              _c("div", { staticClass: "type_gender_serviceman" }, [
                _c("p", { staticClass: "type" }, [
                  _c("img", {
                    attrs: {
                      loading: "lazy",
                      src: _vm.intermentTypeIcon,
                      alt: "",
                    },
                  }),
                  _vm._v(" "),
                  _c("span", [_vm._v(_vm._s(_vm.intermentTypeName))]),
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "gender" }, [
                  _c("img", {
                    attrs: {
                      loading: "lazy",
                      src: _vm.entityGenderIcon,
                      alt: "",
                    },
                  }),
                  _vm._v(" "),
                  _c("span", [_vm._v(_vm._s(_vm.entityGender))]),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "common-info" }, [
                _c(
                  "ul",
                  [
                    _vm._l(_vm.commonInfo, function (item, idx) {
                      return [
                        _vm.itemInfo(item)
                          ? _c(
                              "li",
                              {
                                key: `interment-item-common-${_vm.indexItem}-${idx}`,
                                class: item,
                              },
                              [
                                _c("label", { staticClass: "pr-2" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        `${_vm.modelTranslateID}.interment.${item}`
                                      )
                                    ) + ":"
                                  ),
                                ]),
                                _vm._v(
                                  _vm._s(_vm.itemInfo(item)) +
                                    "\n                                "
                                ),
                              ]
                            )
                          : _vm._e(),
                      ]
                    }),
                  ],
                  2
                ),
              ]),
              _vm._v(" "),
              _vm.allowViewDetail
                ? _c(
                    "button",
                    {
                      staticClass: "btn view-interment",
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.onViewDetail.apply(null, arguments)
                        },
                      },
                    },
                    [
                      _c("i", { staticClass: "far fa-user" }),
                      _vm._v(" "),
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              `${_vm.baseTranslateID}.buttons.interment.view`
                            )
                          )
                        ),
                      ]),
                    ]
                  )
                : _vm._e(),
            ]),
          ]),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "interment-panel-desc" }, [
      _c("i", { staticClass: "fas fa-chevron-right" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", [_c("div", { staticClass: "container-icons" })])
  },
]
render._withStripped = true

export { render, staticRenderFns }